(function($, undefined) {
	
	'use strict';

	var toggleBill = function() {
		$(this).next('.mg2-admin-person-order-bottom').slideToggle();
	};
	
	var init = function () {
		$('.mg2-admin-person-order-top').click(toggleBill);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
